import React from "react";

import { useTranslation, Trans } from "react-i18next";

import w1 from '../../img/Home/w1.png';
import w2 from '../../img/Home/w2.png';
import w3 from '../../img/Home/w3.png';
import w4 from '../../img/Home/w4.png';

function WhyArvest () {

    const { t } = useTranslation();
      
    return(
        <div className="relative pt-[90px] xl:pt-[160px]">
            <div className="max-w-[1220px] xl:mx-auto mx-[20px] relative">
                <p className="spantext text-[#0C2780] font-[700] text-[23px] xl:text-[45px] open-sans text-center"><Trans>{t('home.29')}</Trans></p>
                <div className="flex flex-col xl:flex-row justify-between mt-[25px] xl:mt-[60px]">
                    <div>
                        <img src={w1} alt="" className="w-[55px] xl:w-[60px] h-[55px] xl:h-[60px]"/>
                        <p className="mt-[13px] font-[700] text-[16px] text-[#0C2780]">{t('home.30')}</p>
                        <p className="xl:max-w-[525px] open-sans text-[16px] font-[300] text-[#0C2780] mt-[15px]">{t('home.31')}</p>
                    </div>
                    <div className="mt-[25px] xl:mt-0">
                        <img src={w2} alt="" className="w-[55px] xl:w-[60px] h-[55px] xl:h-[60px]"/>
                        <p className="mt-[13px] font-[700] text-[16px] text-[#0C2780]">{t('home.32')}</p>
                        <p className="xl:max-w-[525px] open-sans text-[16px] font-[300] text-[#0C2780] mt-[15px]">{t('home.33')}</p>
                    </div>
                </div>
                <div className="flex flex-col xl:flex-row justify-between mt-[25px] xl:mt-[60px]">
                    <div>
                        <img src={w3} alt="" className="w-[55px] xl:w-[60px] h-[55px] xl:h-[60px]"/>
                        <p className="mt-[13px] font-[700] text-[16px] text-[#0C2780]">{t('home.34')}</p>
                        <p className="xl:max-w-[525px] open-sans text-[16px] font-[300] text-[#0C2780] mt-[15px] fontfont"><Trans>{t('home.35')}</Trans></p>
                    </div>
                    <div className="mt-[25px] xl:mt-0">
                        <img src={w4} alt="" className="w-[55px] xl:w-[60px] h-[55px] xl:h-[60px]"/>
                        <p className="mt-[13px] font-[700] text-[16px] text-[#0C2780]">{t('home.36')}</p>
                        <p className="xl:max-w-[525px] open-sans text-[16px] font-[300] text-[#0C2780] mt-[15px] fontfont"><Trans>{t('home.37')}</Trans></p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default WhyArvest;